//  document.addEventListener("DOMContentLoaded", function () {
//   const words = document.querySelectorAll('.text-rotator .rotator-word');
//   let index = 0;

//   function rotateText() {
//     if(words.length > 0)
//     {
//       words[index].classList.remove('is-visible');
//       words[index].classList.add('is-hidden');

//       index = (index + 1) % words.length;

//       words[index].classList.remove('is-hidden');
//       words[index].classList.add('is-visible');
//     }
//   }

//   setInterval(rotateText, 2000);
// });


// document.addEventListener('DOMContentLoaded', function () {

//   function updateCartAttributes() {
//     const data = {
//       attributes: {
//         'Vehicle Registration': document.getElementById('registration')?.value || '',
//         'Make': document.getElementById('make')?.value || '',
//         'Model': document.getElementById('model')?.value || '',
//         'Year': document.getElementById('year')?.value || '',
//         'VN Number': document.getElementById('vn')?.value || '',
//         'Image1': document.getElementById('u1')?.value || '',
//         'Image2': document.getElementById('u2')?.value || '',
//         'Image3': document.getElementById('u3')?.value || ''
//       }
//     };

//     fetch('/cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(data)
//     })
//     .then(response => response.json())
//     .then(() => {

//       console.log('Vehicle data saved in cart attributes', data);
//     })
//     .catch(error => {
//       console.error('Cart attribute update failed', error);
//     });
//   }

//   const fields = ['registration', 'make', 'model', 'year', 'vn', 'u1', 'u2', 'u3'];

//   fields.forEach(function (id) {
//     const input = document.getElementById(id);
//     if (!input) return;

//     input.addEventListener('change', updateCartAttributes);
//     input.addEventListener('blur', updateCartAttributes);
//   });

// });


document.addEventListener("DOMContentLoaded", function () {
  const words = document.querySelectorAll('.text-rotator .rotator-word');
  const images = document.querySelectorAll('.hero-image .rotator-image');
  let index = 0;

  function rotateContent() {
    if (words.length === 0 || images.length === 0) return;

    // Hide current
    words[index].classList.remove('is-visible');
    words[index].classList.add('is-hidden');

    images[index].classList.remove('is-visible');
    images[index].classList.add('is-hidden');

    // Next index
    index = (index + 1) % words.length;

    // images[index].style.top = '-50px';  
    // images[index].style.opacity = '0';

    // Show next
    words[index].classList.remove('is-hidden');
    words[index].classList.add('is-visible');

    images[index].classList.remove('is-hidden');
    images[index].classList.add('is-visible');

    // images[index].style.top = '10px';
    // images[index].style.opacity = '0';
  }

  setInterval(rotateContent, 2000);
});
